import * as React from "react";
import Typography from "@mui/material/Typography";

export default function ReportTypography({ title }) {
	return (
        <Typography sx={{ fontWeight: 300, fontSize: 15 }} variant="h6" component="div">
            {title}
        </Typography>
	);
}